import { GET } from './api'

export const Read = async () => {
    return await GET(`/cad-cotistas?_limit=-1`, true, true);
}
